// import React, { useMemo, useState } from "react";
// import {
//   Drawer,
//   DrawerBody,
//   DrawerFooter,
//   DrawerHeader,
//   DrawerOverlay,
//   DrawerContent,
//   DrawerCloseButton,
//   Checkbox,
//   Input,
//   useToast,
// } from "@chakra-ui/react";
// import Select from "react-select";
// import { dateConditions, dropdownConditions, item, stringConditions } from "../utils/SearchPickList";
// import { useSelector } from "react-redux";

// export default function BOMSearchDrawer({ isSearchDrawerOpen, closeDrawer, onSearch }) {
//       const filtersConfig = [
//     { key: "bom", label: "BOM", optionsType: "string" },
//     { key: "item", label: "Finished Good Item", optionsType: "dropdown" },
//     { key: "color", label: "Color", optionsType: "dropdown" },
//     { key: "version", label: "Version", optionsType: "string" },
//     { key: "createdBy", label: "Created By", optionsType: "dropdown" },
//     { key: "modifiedBy", label: "Modified By", optionsType: "dropdown" },
  
//   ];

//    const toast = useToast();

//   const inventory = useSelector((state) => state.inventory?.inventory) || [];

//    const [filters, setFilters] = useState(
//         filtersConfig.reduce((acc, f) => {
//           acc[f.key] = {
//             checked: false,
//             condition: { label: "Is", value: "is" },
//             showInput: false,
//             value: "",
//           };
//           return acc;
//         }, {})
//       );

//        const handleCheckboxChange = (key) => (e) => {
//       const checked = e.target.checked;
//       setFilters((prev) => ({
//         ...prev,
//         [key]: {
//           ...prev[key],
//           checked,
//           condition: { label: "Is", value: "is" },
//           showInput: checked,
//           value: "",
//         },
//       }));
//     };

//       const handleConditionChange = (key) => (selected) => {
//       const hideInputFor = ["is-empty", "is-not-empty"];
  
//       setFilters((prev) => ({
//         ...prev,
//         [key]: {
//           ...prev[key],
//           condition: selected,
//           showInput: !hideInputFor.includes(selected.value),
//         },
//       }));
//     };

//      const handleValueChange = (key) => (value) => {
//       setFilters((prev) => ({
//         ...prev,
//         [key]: { ...prev[key], value },
//       }));
//     };

//      const itemOptions = useMemo(() => {
//       return inventory.map((product) => ({
//         value: product.ROWID,
//         label: product.itemName,
//       }));
//      }, [inventory]);

//       const getOptions = (type) => {
//     switch (type) {
//       case "item":
//         return itemOptions;
//       default:
//         return [];
//     }
//   };

  

//     const handleOnClose = () => {
//     setFilters(
//       filtersConfig.reduce((acc, f) => {
//         acc[f.key] = {
//           checked: false,
//           condition: { label: "Is", value: "is" },
//           showInput: false,
//           value: "",
//         };
//         return acc;
//       }, {})
//     );
//     closeDrawer();
//   };

  

  

//   const handleSearch = () => {
//     const search = [];
//     // const activeFilters = {};
//     Object.keys(filters).forEach((key) => {
//      const filter = filters[key];
//      if(!filter.checked) return;

//       const operation = filter.condition.value;
//       const value = filter.value;

//      if (["is-empty", "is-not-empty"].includes(operation)) {
//       search.push({ field: key, operation, value: "" });
//       return;
//      }

//      if (!value) return;

//      search.push({ field: key, operation, value });
//     });

//     if (onSearch) {
//       onSearch(search);
//     }
    
//     toast({
//       title: 'Search Applied',
//       status: 'success',
//       duration: 2000,
//       isClosable: true,
//       position: 'top-left',
//     });
//     closeDrawer();
//   };
// const handleReset = () => {
//     setFilters(
//         filtersConfig.reduce((acc, f) => {
//             acc[f.key] = {
//                 checked: false,
//                 condition: { label: "Is", value: "is" },
//                 showInput: false,
//                 value: "",
//             };
//             return acc;
//         }, {})
//     );
// };

//   return (
//       <Drawer
//               isOpen={isSearchDrawerOpen}
//               placement="right"
//               size="xs"
//               onClose={handleOnClose}
//             >
//               <DrawerOverlay />
//               <DrawerContent>
//                 <DrawerCloseButton />          
//                 <DrawerHeader>
//                   <div className="d-flex justify-content-start align-items-center gap-4">
//             <span>Search BOM</span>
//                <button className="reset-btn" onClick={handleReset}> Reset</button>

// </div>  
//                 </DrawerHeader>
        
//                 <DrawerBody>
//                   {filtersConfig.map(({ key, label, optionsType }) => {
//                     const current = filters[key];
        
//                     return (
//                       <div className="mt-3" key={key}>
//                         <Checkbox
//                           isChecked={current.checked}
//                           onChange={handleCheckboxChange(key)}
//                         >
//                           {label}
//                         </Checkbox>
        
//                         {current.checked && (
//                           <>
//                             {/* Condition */}
//                             <div className="mt-2">
//                               <Select


//                                 options={
//                                   optionsType === "date"
//                                     ? dateConditions
//                                     : optionsType === "item" 
//                                     ? dropdownConditions
//                                     : stringConditions
                                    


//                                 }
//                                 value={current.condition}
//                                 onChange={handleConditionChange(key)}
//                               />
//                             </div>
        
//                             {/* Value */}
//                             {current.showInput && (
//                               <>
//                                 {optionsType === "item" ? (
//                                   <Select
//                                   isClearable
//                                     className="mt-2"
//                                     options={getOptions(optionsType)}
//                                     placeholder={`Select ${label}`}
//                                     // onChange={(opt) =>
//                                     //   handleValueChange(key)(opt.value)
//                                     onChange={(opt) => handleValueChange(key)(opt ? opt.value : "")}
//                                     value={getOptions(optionsType).find(option => option.value === current.value) || null}


                                    
//                                   />
//                                 ) : (
//                                   <Input
//                                     className="mt-2"
//                                     type={
//                                       optionsType === "date"
//                                         ? "date"
//                                         : "text"
//                                     }
//                                     placeholder={`Enter ${label}`}
//                                     onChange={(e) =>
//                                       handleValueChange(key)(e.target.value)
//                                     }
//                                   />
//                                 )}
//                               </>
//                             )}
//                           </>
//                         )}
//                       </div>
//                     );
//                   })}
//                 </DrawerBody>
        
//                 <center>
//                   <DrawerFooter style={{ display: "inline-block" }}>
//                     <div className="d-flex gap-3">
//                       <button className="cancel-button" onClick={handleOnClose}>
//                         Cancel
//                       </button>
//                       <button
//                         className="main-btn"
//                         onClick={handleSearch}
//                       >
//                         <span className="inner-content">Search</span>
//                       </button>
//                     </div>
//                   </DrawerFooter>
//                 </center>
//               </DrawerContent>
//             </Drawer>
//   )
// }
import React, { useMemo, useState, useEffect } from "react";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Checkbox,
  Input,
  useToast,
} from "@chakra-ui/react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  stringConditions,
  dropdownConditions,
} from "../utils/SearchPickList";
import { getColoursList } from "../../../redux/reduxApi/admin/ColourReduxApi";
import { getEmployeesList } from "../../../redux/reduxApi/admin/EmployeesReduxApi";

export default function BOMSearchDrawer({ isSearchDrawerOpen, closeDrawer, onSearch }) {
  const dispatch = useDispatch();
  const toast = useToast();

  // Get data from Redux store
  const inventory = useSelector((state) => state?.inventory?.inventory) || [];
  const colourList = useSelector((state) => state?.colour?.colour) || [];
  const employeesList = useSelector((state) => state?.employees?.employees) || [];

  // State for dynamic options
  const [colourOptions, setColourOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [colourLoading, setColourLoading] = useState(false);
  const [employeeLoading, setEmployeeLoading] = useState(false);

  /* -------------------- FILTER CONFIG -------------------- */
  const filtersConfig = [
    { key: "bom", label: "BOM", optionsType: "string" },
    { key: "item", label: "Item", optionsType: "dropdown" },
    { key: "colour", label: "Colour", optionsType: "dropdown" },
    { key: "version", label: "Version", optionsType: "string" },
    { key: "createdBy", label: "Created By", optionsType: "dropdown" },
    { key: "modifiedBy", label: "Modified By", optionsType: "dropdown" },
  ];

  /* -------------------- STATE -------------------- */
  const [filters, setFilters] = useState(
    filtersConfig.reduce((acc, f) => {
      acc[f.key] = {
        checked: false,
        condition: { label: "Is", value: "is" },
        showInput: false,
        value: "",
      };
      return acc;
    }, {})
  );

  /* -------------------- FETCH DYNAMIC DATA -------------------- */

  // Fetch colours
  useEffect(() => {
    setColourLoading(true);
    dispatch(getColoursList())
      .finally(() => setColourLoading(false));
  }, [dispatch]);

  // Fetch employees
  useEffect(() => {
    setEmployeeLoading(true);
    dispatch(getEmployeesList({ page: 1, size: 30, limit: 30 }))
      .finally(() => setEmployeeLoading(false));
  }, [dispatch]);

  // Update colour options
  useEffect(() => {
    if (colourList && colourList.length > 0) {
      const options = colourList.map(colour => ({
        value: colour.ROWID,
        label: colour.colour || colour.name || "Unknown",
      }));
      setColourOptions(options);
    } else {
      setColourOptions([]);
    }
  }, [colourList]);

  // Update employee options
  useEffect(() => {
    if (employeesList && employeesList.length > 0) {
      const options = employeesList.map(emp => ({
        value: emp.ROWID,
        label: `${emp.firstName || ""} ${emp.lastName || ""}`.trim() || emp.email || emp.employeeName || "Unknown",
      }));
      setEmployeeOptions(options);
    } else {
      setEmployeeOptions([]);
    }
  }, [employeesList]);

  /* -------------------- MEMOIZED OPTIONS -------------------- */

  // Item options from inventory
  const itemOptions = useMemo(() => {
    return inventory.map((product) => ({
      value: product.ROWID,
      label: product.itemName || product.name || "Unknown",
      product: product,
    }));
  }, [inventory]);

  /* -------------------- HANDLERS -------------------- */

  const handleCheckboxChange = (key) => (e) => {
    const checked = e.target.checked;
    setFilters((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        checked,
        condition: { label: "Is", value: "is" },
        showInput: checked,
        value: "",
      },
    }));
  };

  const handleConditionChange = (key) => (selected) => {
    const hideInputFor = ["is-empty", "is-not-empty"];

    setFilters((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        condition: selected,
        showInput: !hideInputFor.includes(selected.value),
      },
    }));
  };

  const handleValueChange = (key) => (value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: { ...prev[key], value },
    }));
  };

  const getOptions = (key) => {
    switch (key) {
      case "item":
        return itemOptions;
      case "colour":
        return colourOptions;
      case "createdBy":
        return employeeOptions;
      case "modifiedBy":
        return employeeOptions;
      default:
        return [];
    }
  };

  const getLoadingState = (key) => {
    switch (key) {
      case "colour":
        return colourLoading;
      case "createdBy":
      case "modifiedBy":
        return employeeLoading;
      default:
        return false;
    }
  };

  const getConditionOptions = (optionsType) => {
    switch (optionsType) {
      case "dropdown":
        return dropdownConditions;
      default:
        return stringConditions;
    }
  };

  /* -------------------- SEARCH -------------------- */

  const handleSearch = () => {
    const search = [];

    filtersConfig.forEach(({ key }) => {
      const current = filters[key];
      if (!current.checked) return;

      const operation = current.condition?.value || "is";
      let value = current.value;

      if (["is-empty", "is-not-empty"].includes(operation)) {
        search.push({ field: key, operation, value: "" });
        return;
      }

      if (!value && value !== 0) return;

      search.push({ field: key, operation, value });
    });

    if (search.length === 0) {
      toast({
        title: "Please select at least one filter",
        status: "warning",
        duration: 3000,
        isClosable: true,
        position: "top-left",
      });
      return;
    }

    if (onSearch) {
      onSearch(search);
    }

    toast({
      title: "Search Applied",
      status: "success",
      duration: 2000,
      isClosable: true,
      position: "top-left",
    });
    closeDrawer();
  };

  /* -------------------- RESET -------------------- */

  const handleReset = () => {
    setFilters(
      filtersConfig.reduce((acc, f) => {
        acc[f.key] = {
          checked: false,
          condition: { label: "Is", value: "is" },
          showInput: false,
          value: "",
        };
        return acc;
      }, {})
    );
  };

  const handleOnClose = () => {
    handleReset();
    closeDrawer();
  };

  /* -------------------- UI -------------------- */

  return (
    <Drawer
      isOpen={isSearchDrawerOpen}
      placement="right"
      size="xs"
      onClose={handleOnClose}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />

        <DrawerHeader>
          <div className="d-flex justify-content-start align-items-center gap-4">
            <span>Search BOM</span>
            <button className="reset-btn" onClick={handleReset}>
              Reset
            </button>
          </div>
        </DrawerHeader>

        <DrawerBody>
          {filtersConfig.map(({ key, label, optionsType }) => {
            const current = filters[key];
            const isDropdown = optionsType === "dropdown";

            return (
              <div className="mt-3" key={key}>
                <Checkbox
                  isChecked={current.checked}
                  onChange={handleCheckboxChange(key)}
                >
                  {label}
                </Checkbox>

                {current.checked && (
                  <>
                    {/* Condition */}
                    <div className="mt-2">
                      <Select
                        options={getConditionOptions(optionsType)}
                        value={current.condition}
                        onChange={handleConditionChange(key)}
                      />
                    </div>

                    {/* Value */}
                    {current.showInput && (
                      <>
                        {isDropdown ? (
                          <Select
                            isClearable
                            className="mt-2"
                            options={getOptions(key)}
                            placeholder={`Select ${label}`}
                            isLoading={getLoadingState(key)}
                            onChange={(opt) =>
                              handleValueChange(key)(opt ? opt.value : "")
                            }
                            value={
                              getOptions(key).find(
                                (option) => option.value === current.value
                              ) || null
                            }
                          />
                        ) : (
                          <Input
                            className="mt-2"
                            type="text"
                            placeholder={`Enter ${label}`}
                            value={current.value || ""}
                            onChange={(e) =>
                              handleValueChange(key)(e.target.value)
                            }
                          />
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </DrawerBody>

        <center>
          <DrawerFooter style={{ display: "inline-block" }}>
            <div className="d-flex gap-3">
              <button className="cancel-button" onClick={handleOnClose}>
                Cancel
              </button>
              <button className="main-btn" onClick={handleSearch}>
                <span className="inner-content">Search</span>
              </button>
            </div>
          </DrawerFooter>
        </center>
      </DrawerContent>
    </Drawer>
  );
}